import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useHasRights,
  useUserRights,
} from "../../../contexts/UserRightsContext";
import Changes from "../../common/Changes";
import PlayerHistory from "./PlayerHistory";
import PlayerMarketing from "./PlayerMarketing";
import PlayerNotes from "./PlayerNotes";
import PlayerOpenBets from "./PlayerOpenBets";
import PlayerPayment from "./PlayerPayment";
import PlayerSettings from "./PlayerSettings";
import "./PlayerTabs.css";
import PlayerWagering from "./PlayerWagering";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index || props.hidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PlayerTabs(props) {

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const history = useHistory();
  const [value, setValue] = useState(0);
  const handleChange = useCallback((event, newValue) => {
    setValue(newValue);

    props.setStatisticsToReload?.();

  }, [props.setStatisticsToReload]);

  const handleSave = () => {
    if (!props.Player?.idPlayer) {
      props.InsertPlayer(props.Player);
    } else {
      props.Updateplayer(props.Player);
    }
  };

  const handleClose = () => {
    history.push("/profiles");
  };

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const onDateChange = useCallback((event) => setDate(event.target.value), []);

  const [reason, setReason] = useState("");
  const onReasonChange = useCallback(
    (event) => setReason(event.target.value),
    []
  );

  const handleChangeClone = (event) => {
    const { name, value } = event.target;
    setClonePlayer((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Si se requiere que estos datos formen parte de la data para insert, se podría:
    // props.updatePlayerField(name, value);
  };

  const [openBlackBook, setOpenBlackBook] = useState(false);
  const onOpenBlackBookChange = useCallback(
    (open) => setOpenBlackBook(open),
    []
  );

  const handleBlackBook = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Player/Player_InsertBlackBook`;
    axios
      .post(url, {
        IdPlayer: props.Player.idPlayer,
        SettleDate: date,
        Description: reason,
        IdUser: userInfo.userId,
      })
      .then((response) => {
        if (response.data === 0) {
          toast.error(`Error blacklisting player ${props.Player.player}`);
        } else {
          toast.success(`${props.Player.player} blacklisted successfully`);
        }
        onOpenBlackBookChange(false);
      });
  }, [props.Player, date, reason, userInfo.userId, onOpenBlackBookChange]);

  const [openResetStatistics, setOpenResetStatistics] = useState(false);
  const [isClone, setIsClone] = useState(false);
  const [clonePlayer, setClonePlayer] = useState({
    Player: "",
    Password: "",
    Name: "",
    LastName: "",
    LastName2: "",
  });

  const onOpenResetStatisticsChange = useCallback(
    (open) => setOpenResetStatistics(open),
    []
  );

  const toggleIsClone = () => {
    setIsClone(!isClone);
  };

  const ClonePlayer = () => {
    if (clonePlayer.Player === "" || clonePlayer.Password === "") {
      return;
    }

    let request = {
      SourcePlayer: props.Player.idPlayer,
      Player: clonePlayer.Player,
      Password: clonePlayer.Password,
      Name: clonePlayer.Name,
      LastName: clonePlayer.LastName,
      LastName2: clonePlayer.LastName2,
      Title: "Mr",
      OnlinePassword: clonePlayer.Password,
      IdUser: userInfo.userId,
      IdPlayer: props.Player.idPlayer,
      Result: 0,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/Player_Clone",
      data: request,
    }).then((response) => {
      if (response.data.Result === 0) {
        setIsClone(false);
        toast.success(`Player cloned successfully.`);
      } else {
        toast.error(`An error occurred while cloning the player.`);
      }
    });
  };

  const handleResetStatistics = useCallback(() => {


    const url = `${process.env.REACT_APP_API2_URL}/Player/Player_ResetStats`;

    axios
      .post(url, {
        IdPlayer: props.Player.idPlayer,
        IdUser: userInfo.userId,
      })
      .then((response) => {
        if (response.data === -1) {
          toast.error(`Error reseting stats for player ${props.Player.player}`);
        } else {
          toast.success(`${props.Player.player} stats reset successfully`);
        }

        onOpenResetStatisticsChange(false);

        props.requestPlayerInfo(props.Player.idPlayer);
      });

  }, [props.Player, userInfo.userId, onOpenResetStatisticsChange, props.requestPlayerInfo]);

  const { data: rights } = useUserRights();

  const canBlackBook = rights?.includes(30);
  const hasRights = (...ids) => ids.some((id) => rights?.includes(id));

  return (
    <React.Fragment>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        className="w-full mb-2 overflow-x-scroll tabs-class"
      >
        <Tab label="Wagering" {...a11yProps(0)} />
        <Tab label="Settings / Notes" {...a11yProps(1)} />
        <Tab label="Online Messages" {...a11yProps(2)} />
        <Tab label="Marketing" {...a11yProps(3)} />
        <Tab label="Open Bets" {...a11yProps(4)} hidden={!hasRights(38)} />
        <Tab label="History" {...a11yProps(5)} hidden={!hasRights(35)} />
        <Tab
          label="Payment"
          {...a11yProps(6)}
          hidden={!hasRights(32, 43, 42, 34, 33, 128)}
        />
      </Tabs>
      <hr className="my-2" />
      <TabPanel className="tab-content" value={value} index={0}>
        <PlayerWagering
          Player={props.Player}
          Updateplayer={props.Updateplayer}
          InsertPlayer={props.InsertPlayer}
          updatePlayerField={props.updatePlayerField}
        />
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={1}>
        <TabPanel className="tab-content" value={value} index={1}>
          <PlayerSettings
            Player={props.Player}
            UpdatePlayer={props.Updateplayer}
          />
        </TabPanel>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={2}>
        <PlayerNotes Player={props.Player} />
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={3}>
        <PlayerMarketing
          Player={props.Player}
          UpdatePlayer={props.Updateplayer}
        />
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={4}
        hidden={!hasRights(38)}
      >
        <PlayerOpenBets Player={props.Player} />
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={5}
        hidden={!hasRights(35)}
      >
        <PlayerHistory Player={props.Player} />
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={6}
        hidden={!hasRights(32, 43, 42, 34, 33, 128)}
      >
        <PlayerPayment
          setStatisticsToReload={props.setStatisticsToReload}
          requestPlayerInfo={props.requestPlayerInfo}
          Player={props.Player}
        />
      </TabPanel>

      <div className="flex flex-row justify-between gap-4">
        <div className="flex flex-row gap-4">
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            {props.Player.idPlayer == 0 ? "Add" : "Save"}
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            {props.Player.idPlayer == 0 ? "Cancel" : "Close"}
          </Button>
          <Button size="small" variant="contained" color="primary" onClick={toggleIsClone}>
            Clone
          </Button>
          <Button
            hidden={!canBlackBook}
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onOpenBlackBookChange(true)}
          >
            Black Book
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onOpenResetStatisticsChange(true)}
          >
            Reset Stats
          </Button>
        </div>

        <Changes
          hidden={!hasRights(41)}
          title="Player Changes"
          params={{
            ChangeType: 1,
            IdSport: "",
            Param1: props.Player.idPlayer,
            Param2: 0,
            Param3: 0,
          }}
        />
      </div>

      <Dialog
        open={openBlackBook}
        onClose={onOpenBlackBookChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Add Player to Black Book</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="flex flex-col gap-4">
              <TextField
                required
                variant="outlined"
                label="Player"
                type="text"
                disabled
                value={props.Player.player}
                size="small"
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                required
                variant="outlined"
                label="Reason"
                type="text"
                value={reason}
                size="small"
                onChange={onReasonChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                required
                variant="outlined"
                label="Date"
                type="date"
                value={date}
                size="small"
                onChange={onDateChange}
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBlackBook} color="primary" variant="contained">
            Ok
          </Button>
          <Button
            onClick={() => onOpenBlackBookChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openResetStatistics}
        onClose={onOpenResetStatisticsChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reset statistics?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleResetStatistics}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
          <Button
            onClick={() => onOpenResetStatisticsChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {isClone && (
        <div className="modal-clone">
          <div className="modal-clone-card">
            <h2>Clone Player: {props.Player.player} </h2>
            <div className="modal-clone-card-grid grid grid-cols-2 gap-3">
              <TextField
                required
                variant="outlined"
                label="Player"
                name="Player"
                type="text"
                value={clonePlayer.Player}
                size="small"
                onChange={handleChangeClone}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                required
                variant="outlined"
                label="Name"
                type="text"
                name="Name"
                value={clonePlayer.Name}
                size="small"
                onChange={handleChangeClone}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                required
                variant="outlined"
                label="Password"
                type="text"
                name="Password"
                value={clonePlayer.Password}
                size="small"
                onChange={handleChangeClone}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                required
                variant="outlined"
                label="Last Name"
                type="text"
                name="LastName"
                value={clonePlayer.LastName}
                size="small"
                onChange={handleChangeClone}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                variant="outlined"
                label="Last Name 2:"
                type="text"
                name="LastName2"
                value={clonePlayer.LastName2}
                size="small"
                onChange={handleChangeClone}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className="flex justify-center gap-3 mt-4">
              <Button
                color="primary"
                variant="contained"
                onClick={ClonePlayer}
              >
                Clone
              </Button>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setIsClone(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}